import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconPanelLeft = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="9" y1="3" x2="9" y2="21" />
  </SidebarIconSvg>
);

SidebarIconPanelLeft.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconPanelLeft;
